import { AliceSkillName, ConfigEnemy, CurrentEnemy, HackneyGraphId, PlayerProfile, ServerResponse, ShopConfig } from "../../../types/alice-bob";
import { getHeaders, getHeadersJWT } from "./header";

const STORAGE_API_HOST = "https://backend.alice-bob.hackney.games";
const TG_GATEWAY_API_HOST = "https://tg-gateway.hackney.games";

export type FirstResponse = {
    player: PlayerProfile,
    shop: ShopConfig,
    refs: any
    // updated_previous: number,
    afk_reward: number,
    afk_time: number
    game_config: any,
}

export const handleResponse = async (response: Response, methodName: string): Promise<{ status: number, body: any }> => {
    const status = response.status;

    if (status !== 200) {
        throw new Error('Issues on request ' + methodName + '. Error status ' + status);
    }

    // Read the body as text first
    const text = await response.text();
    let body;

    try {
        body = JSON.parse(text)
    } catch (err) {
        console.log("JSON parse failed, showing raw text instead:", err);
        body = text;
        console.log("JSON parse failed, showing raw text body instead:", body);
    }
    // console.log("JSON request succeeded. Before exit");
    return { status, body };
}

export const telegramAuth = async () => {
    // console.log('Preparing for telegramAuth')
    const authPayload = {
        initData: window.Telegram.WebApp.initData,
        botId: 'AliceBobGame_bot',
        start_param: window.Telegram.WebApp.initDataUnsafe.start_param,
    };
    // console.log('authPayload ' + authPayload)
    const requestOptions = {
        method: "POST",
        headers: getHeaders(),
        body: JSON.stringify(authPayload),
    };

    const response = await fetch(
        `${STORAGE_API_HOST}/id/telegram`,
        requestOptions
    );
    // console.log("telegramAuth res:", JSON.stringify(response));

    const { status, body } = await handleResponse(response, 'telegramAuth');

    return { status, body };
};

export const wipeMe = async (): Promise<any> => {
    const requestOptions = {
        method: "POST",
        headers: await getHeadersJWT(),
    };

    const response = await fetch(`${STORAGE_API_HOST}/wipe-me`, requestOptions);
    const status = response.status;

    if (status !== 200) {
        throw new Error();
    }

    const responseClone = response.clone();
    const bodyText = await responseClone.text();

    if (!bodyText) {
        throw new Error();
    }

    return await response.json();
};

export const getMe = async (): Promise<FirstResponse> => {
    const requestOptions = {
        method: "GET",
        headers: await getHeadersJWT(),
    };

    const response = await fetch(`${STORAGE_API_HOST}/me`, requestOptions);
    const status = response.status;

    if (status !== 200) {
        throw new Error("Authentication failed with " + JSON.stringify(requestOptions));
    }

    const responseClone = response.clone();
    const bodyText = await responseClone.text();

    if (!bodyText) {
        throw new Error("Authentication failed with " + JSON.stringify(requestOptions));
    }

    const body = await response.json();

    const game_config = {
        ...body.game_config,
        unixtime: body.game_config.unixtime,
    };

    const player: PlayerProfile = { ...body.player };
    const shop: ShopConfig = { ...body.shop };
    const refs: Array<HackneyGraphId> = body.refs;
    const { afk_reward, afk_time } = body;

    return {
        player,
        shop,
        refs,
        afk_reward, afk_time,
        game_config
        // config, shop 
    };
};

export const getStarsInvoice = async (itemId: string) => {
    const requestOptions = {
        method: "GET",
        headers: await getHeadersJWT(),
    };

    const response = await fetch(
        `${TG_GATEWAY_API_HOST}/payments/AliceBobGame_bot/invoice/` + itemId,
        requestOptions,
    );
    const status = response.status;

    if (status !== 200) {
        throw new Error();
    }

    const body = (await response.json()).paymentLink;

    return body;
};

export const getLeaders = async (): Promise<Array<PlayerProfile>> => {
    const requestOptions = {
        method: "GET",
        headers: await getHeadersJWT(),
    };

    const response = await fetch(`${STORAGE_API_HOST}/ranking`, requestOptions);
    const status = response.status;

    if (status !== 200) {
        throw new Error();
    }

    const responseClone = response.clone();
    const bodyText = await responseClone.text();

    if (!bodyText) {
        throw new Error();
    }

    const body = await response.json();

    return body;
};

export const sync = async (playerSyncData: PlayerProfile): Promise<ServerResponse> => {
    const requestOptions = {
        method: "POST",
        headers: await getHeadersJWT(),
        body: JSON.stringify({ playerSyncData }),
    };

    const response = await fetch(`${STORAGE_API_HOST}/sync`, requestOptions);
    const status = response.status;

    if (status !== 200) {
        throw new Error();
    }

    const responseClone = response.clone();
    const bodyText = await responseClone.text();

    if (!bodyText) {
        throw new Error();
    }

    return await response.json();
};

export const claimFriendApi = async (friendHackneyId: string): Promise<ServerResponse> => {
    const requestOptions = {
        method: "POST",
        headers: await getHeadersJWT(),
        body: JSON.stringify({ friendHackneyId }),
    };

    const response = await fetch(`${STORAGE_API_HOST}/friends/claim`, requestOptions);
    const status = response.status;

    if (status !== 200) {
        throw new Error();
    }

    const responseClone = response.clone();
    const bodyText = await responseClone.text();

    if (!bodyText) {
        throw new Error();
    }

    return await response.json();
};

export const convertGems = async (covertId: string): Promise<ServerResponse> => {
    const requestOptions = {
        method: "POST",
        headers: await getHeadersJWT(),
        body: JSON.stringify({ covertId }),
    };

    const response = await fetch(`${STORAGE_API_HOST}/convert`, requestOptions);
    const status = response.status;

    if (status !== 200) {
        throw new Error();
    }

    const responseClone = response.clone();
    const bodyText = await responseClone.text();

    if (!bodyText) {
        throw new Error();
    }

    return await response.json();
};

export const killApi = async (params: { currentEnergy: number, currentSoft: number, killed: boolean, alice: Record<AliceSkillName, number> }): Promise<ServerResponse> => {
    const requestOptions = {
        method: "POST",
        headers: await getHeadersJWT(),
        body: JSON.stringify(params),
    };

    const response = await fetch(`${STORAGE_API_HOST}/kill`, requestOptions);
    const status = response.status;

    if (status !== 200) {
        throw new Error();
    }

    const responseClone = response.clone();
    const bodyText = await responseClone.text();

    if (!bodyText) {
        throw new Error();
    }

    return await response.json();
};